import { OMSDropdown } from "../../../app/common/common-components/OMSDropdown";
import { OMSNumericBox } from "../../../app/common/common-components/OMSComponent";
import { OMSSocialMediaBox } from "../../../app/common/common-components/OMSSocialBox";

const ProfileTab = ({ state, data, handleChange, handleDialingCodeChange, handlePhoneChange, handleContactChange, handlePublishToPortalChanged }) => {
  return (
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label htmlFor="Profile">Public profile</label>
          <textarea rows={3} className="form-control" id="Profile" name="Profile" value={state.Profile} onChange={handleChange} />
        </div>
        <div className="form-group">
          <label htmlFor="Credentials">Credentials</label>
          <textarea rows={2} className="form-control" id="Credentials" name="Credentials" value={state.Credentials} onChange={handleChange} />
        </div>

        <div className="form-group">
          <label htmlFor="Job">Job title</label>
          <input type="text" className="form-control" id="Job" name="Job" value={state.Job} onChange={handleChange} />
        </div>

        <div className="form-group cellphones">
          <label htmlFor="phone">Mobile number</label>
          <br />
          <div className="dialingcode">
            <OMSDropdown
              id="DialingCode"
              options={data.dialingCodeDD}
              valueField="value"
              labelField="text"
              value={state.Contact.phone_dialing_code}
              onChange={handleDialingCodeChange}
            />
          </div>
          <div className="phonenumber">
            <OMSNumericBox id="Phone" name="Phone" maxLength={10} value={state.Contact.phone} onChange={handlePhoneChange} />
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="social">Social media handles</label>
          <div className="form-inline">
            <OMSSocialMediaBox id="socialBoxItem" name="socialBoxItem" value={state.Contact} onChange={handleContactChange} boxType={1} />
          </div>
        </div>
        <div className="form-group">
          <label className="switch">
            <input type="checkbox" id="isPublishToPortal" name="isPublishToPortal" checked={state.isPublishToPortals} onChange={handlePublishToPortalChanged} />
            <div className="slider round" />
            <span
              style={{
                marginLeft: 70,
                display: "block",
                width: 120,
                marginTop: 7,
              }}
            >
              Publish to portal
            </span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default ProfileTab;
